import React from 'react';
import { FormNumber } from '@digital/ui';
import { Props } from '@digital/ui/lib/components/FormNumber';

export const CurrencyInput3 = ({
    ...props
}: Props &
    import('@digital/ui/lib/components/FormItem').FormItemProps &
    import('antd/lib/input-number').InputNumberProps) => {
    const handleParser = (number: string) => {

        if (!number) {
            return '';
        }

        var negative = number.includes('-') ? '-' : '';
        let valor = number.replace(/[^0-9]/gm, '');
        let valorFloat = parseFloat(valor) / 100;
        if (isNaN(valorFloat)) return '0,00';
        return negative + valorFloat.toFixed(2);
    };

    const thousandSeparator = (value: any) => {
        if (!value) return;
        let values = value.toString().split('.');

        const v1 = values[0];
        const v2 = values[1];

        if (v1 === '') v1 = 0;
        let integers = v1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        if (v2 == undefined) return integers + ',00';
        if (v2.lenght === 1) return integers + (v2 ? ',' + v2 : '0');

        const v2Mod = parseFloat('0.' + v2)
            .toFixed(5)
            .slice(0, -3)
            .replaceAll('0.', '');

        return integers + (v2 ? ',' + v2Mod : '');
    };

    return <FormNumber parser={handleParser} formatter={e => thousandSeparator(e)} {...props} min={0} maxLength={17} max={10000000000000000} />;
};
